import { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

const links = [
  { label: 'About', href: '#about' },
  { label: 'Work', href: '#work' },
  { label: 'Life', href: '#life' },
  { label: 'Contact', href: '#contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const onHome = location.pathname === '/';

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    if (!onHome) {
      window.location.href = '/' + href;
    } else {
      const el = document.querySelector(href);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? 'py-3' : 'py-5'
      }`}
      style={{
        backgroundColor: scrolled ? 'rgba(250, 246, 238, 0.82)' : 'rgba(245, 240, 232, 0.55)',
        backdropFilter: 'saturate(140%) blur(14px)',
        WebkitBackdropFilter: 'saturate(140%) blur(14px)',
        borderBottom: scrolled ? '1px solid var(--border)' : '1px solid transparent',
      }}
    >
      <div className="max-w-6xl mx-auto px-6 md:px-10 flex items-center justify-between">
        <Link to="/" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="flex items-center gap-2 group">
          <span className="font-display text-[22px] md:text-[24px] tracking-wide" style={{ color: 'var(--ink)' }}>
            RITIKA GHOSH
          </span>
          <span className="inline-block w-[7px] h-[7px] rounded-full" style={{ background: 'var(--terracotta)' }} />
        </Link>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <button
              key={l.href}
              onClick={() => go(l.href)}
              className="text-[12.5px] uppercase tracking-[0.16em] transition-colors duration-300"
              style={{ color: 'var(--ink)' }}
              onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--terracotta)')}
              onMouseLeave={(e) => (e.currentTarget.style.color = 'var(--ink)')}
            >
              {l.label}
            </button>
          ))}
        </nav>

        <button
          className="md:hidden p-2 rounded-full"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
          style={{ color: 'var(--ink)' }}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          className="md:hidden mt-3 mx-6 rounded-2xl shadow-warm"
          style={{ background: 'var(--surface)', border: '1px solid var(--border)' }}
        >
          <nav className="flex flex-col p-2">
            {links.map((l) => (
              <button
                key={l.href}
                onClick={() => go(l.href)}
                className="text-left px-5 py-3 text-[13px] uppercase tracking-[0.16em] rounded-xl"
                style={{ color: 'var(--ink)' }}
              >
                {l.label}
              </button>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}
